import { Actions } from "./actions";
import { IO_ERROR, ErrorAction } from "../../../ajax/state/actions";
import { State } from "../state/state";
import { fromServer, toServer } from "../filters";
import initial from "./state.initial";
import { Utils } from "../../../utils";
import { ReducerActions, createReducerActions } from "../../../Store/reducer";

type Actions =
  | Actions.GetRequest
  | Actions.PostRequest
  | Actions.GetResponse
  | Actions.PostResponse
  | Actions.Edit
  | ErrorAction;

const actions: ReducerActions<State.Props, Actions> = {
  [Actions.REQUEST_GET]: getRequest,
  [Actions.REQUEST_POST]: postRequest,
  [Actions.RESPONSE_GET]: getResponse,
  [Actions.RESPONSE_POST]: postResponse,
  [Actions.EDIT]: edit,
  [IO_ERROR]: error
};

export default createReducerActions(actions, initial);

/**
 * @brief Action [REQUEST_GET] reducer
 */
function getRequest(state: State.Props): State.Props {
  return { ...state, loadingGet: true };
}

/**
 * @brief Action [REQUEST_POST] Reducer
 *
 * Convert the UI friendly data into server format with the toServer filter
 */
function postRequest(state: State.Props, action: Actions.PostRequest) {
  action.post = { batt: {} };
  for (let i = 0; i < state.form.length; i++) {
    const diff = toServer(Utils.diff(state.form[i], state.data[i]));
    if (Object.keys(diff).length) action.post.batt[`batt${i}`] = diff;
  }
  return { ...state, loadingPost: true };
}

/**
 * @brief Action [RESPONSE_GET] Reducer
 *
 * Convert the server data into the UI friendlier data format with the
 * fromServer filter.
 */
function getResponse(
  state: State.Props,
  action: Actions.GetResponse
): State.Props {
  let batt: State.Battery[] = [];
  for (let key in action.data.batt) {
    batt.push(fromServer(action.data.batt[key]));
  }
  return {
    ...state,
    status: "OK",
    data: Object.assign([], batt),
    form: Object.assign([], batt),
    submitRequired: false,
    loadingGet: false
  };
}

/**
 * @brief Action [RESPONSE_POST] Reducer
 */
function postResponse(state: State.Props): State.Props {
  return { ...state, loadingPost: false };
}

/**
 * @brief Action [EDIT] Reducer
 *
 * Our action has an index and a Partial<Channel> state change.
 * First part merges the Partial<Channel> change into the original Channel.
 * Then the Changed channel is merged into the original array as a new object.
 *
 * (submitRequired is set if the resulting state changs is different from the
 * original data.)
 */
function edit(state: State.Props, action: Actions.Edit): State.Props {
  const edit = Object.assign({}, state.form[action.idx], action.data);
  let form: State.Data = Object.assign([], state.form, {
    [action.idx]: edit
  });
  let submitRequired: boolean = false;
  form.forEach((ch, idx) => {
    if (Utils.isDiff(ch, state.data[idx])) submitRequired = true;
  });
  return { ...state, ...{ form }, ...{ submitRequired } };
}

function error(state: State.Props): State.Props {
  return { ...state, loadingPost: false, loadingGet: false };
}
